require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/~/core-js/es6/parse-int.js
// module id = ../../../../core-js/es6/parse-int.js
// module chunks = 0